import { useEffect } from 'react';

import { useCurrentUser } from '~/client/hooks/storeHooks';
import { gtmEvent } from '~/client/lib/analytics';

export function useUserAnalytics() {
  const user = useCurrentUser();

  useEffect(() => {
    if (!user) return;

    gtmEvent({
      user_id: user.camdenAccountName,
    });

    return () => {
      gtmEvent({
        user_id: null,
      });
    };
  }, [user]);
}
